import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format number in Spanish style (1.234,56€)
export function formatEUR(value, decimals = 2) {
  if (value === null || value === undefined || isNaN(value)) return '0€';
  return value.toLocaleString('es-ES', { 
    minimumFractionDigits: decimals, 
    maximumFractionDigits: decimals 
  }) + '€';
}

// Format number without decimals in Spanish style (1.234€)
export function formatEURSimple(value) {
  if (value === null || value === undefined || isNaN(value)) return '0€';
  return Math.round(value).toLocaleString('es-ES') + '€';
}

// Format large numbers (847K€, 2M€, etc)
export function formatEURCompact(value) {
  if (value === null || value === undefined || isNaN(value)) return '0€';
  if (value >= 1e12) return `${(value / 1e12).toFixed(2).replace('.', ',')}T€`;
  if (value >= 1e9) return `${(value / 1e9).toFixed(2).replace('.', ',')}B€`;
  if (value >= 1e6) return `${(value / 1e6).toFixed(2).replace('.', ',')}M€`;
  if (value >= 1e3) return `${(value / 1e3).toFixed(0)}K€`;
  return Math.round(value).toLocaleString('es-ES') + '€';
}

// Format price (crypto) in Spanish style
export function formatPrice(price) {
  if (price === null || price === undefined || isNaN(price)) return '0';
  if (price >= 1000) {
    return price.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  if (price >= 1) {
    return price.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 4 });
  }
  return price.toFixed(6).replace('.', ',');
}
